import {Map, SpaceTeam, UserMACR, IntercomDiagramTypes} from '@q9elements/ui-kit/common';
import {ImageFromPreset} from '@q9elements/ui-kit/maps';

export interface MapGenerationPreset {
  name: string;
  description?: string;
  guidance?: string;
  images?: ImageFromPreset[];
}

export interface SignedURLInfo {
  signedUrl: string;
  key: string;
  fileStatus: string;
  previewUrl?: string;
}

export interface MapPayload {
  name: string;
  theme: string;
  language?: string;
  subtype?: string;
  description: string;
  tags: string[];
  guidance: string;
  skipNewResources: boolean;
  team: string;
  type: string;
  'el-team': number;
  token: string;
  autoGenerate: boolean;
  images?: ImagePayload[];
  categories?: string[];
  folderId?: string | null;
}

export interface ImagePayload {
  imageKey: string;
  fileType: string;
}

export interface JsonImportResponse {
  statusCode?: number;
  body: string;
  error?: {error: string};
}

export interface NimbusImportResponse {
  statusCode: number;
  body: {
    importPath: string;
    map: string;
  };
}

export interface TemplatesFilter {
  team: string;
  subtypes: COMMON_SUBTYPES[];
  search: string;
}

export interface TemplateMapsResult {
  list: Map[];
  total: number;
}

export interface TemplateMapsQuery {
  search?: string;
  limit: number;
  skip: number;
  subtypes: COMMON_SUBTYPES[];
  team: string;
  category: string;
}

export interface MapCopyResult {
  _id: string;
  allCanAddNotes: boolean;
  allCanGrantAccess: boolean;
  author: {
    id: string;
    firstName: string;
    lastName: string;
  };
  canCopyMap: boolean;
  canRequestEditRights: boolean;
  copyEnabled: boolean;
  copying: boolean;
  createdAt: string;
  description: string;
  fingerprint: boolean;
  groups: any[];
  id: string;
  isAuthorisationEnabled: boolean;
  isTutor: boolean;
  mapAccess: string;
  name: string;
  organization: SpaceTeam;
  role: string;
  state: string;
  tags: any[];
  team: any;
  topLevelDiagram: any;
  topLevelDiagramState: string;
  type: string;
  updatedAt: string;
  users: UserMACR[];
  view: boolean;
}

export interface CopyMap {
  mapCopy: MapCopyResult;
  jobPath?: string;
}

export type SUBTYPES = AGENT_SUBTYPES | COMMON_SUBTYPES;

export enum COMMON_SUBTYPES {
  UPN = 'upn',
  CAPABILITY = 'capability',
  CUSTOMER_JOURNEY = 'customerJourney',
  SYSTEM_ARCHITECTURE = 'systemArchitecture',
  DATA_MODEL = 'dataModel',
  INTERACTION_FLOW = 'interactionFlow',
  WHITEBOARD = 'whiteboard'
}

export enum AGENT_SUBTYPES {
  AGENT_INSTRUCTION = 'agentInstruction',
  AGENT_INTERACTION = 'agentInteraction'
}

export const architectureSubtypes = new Set([
  COMMON_SUBTYPES.INTERACTION_FLOW,
  COMMON_SUBTYPES.SYSTEM_ARCHITECTURE,
  COMMON_SUBTYPES.DATA_MODEL,
  COMMON_SUBTYPES.CAPABILITY,
  AGENT_SUBTYPES.AGENT_INTERACTION
]);

export interface MapTheme {
  _id: string;
  id: string;
  type: string;
  name: string;
  owner: string;
  team: string;
}

export const typeToEventDisplay = {
  [COMMON_SUBTYPES.UPN]: IntercomDiagramTypes.UPN,
  [COMMON_SUBTYPES.CUSTOMER_JOURNEY]: IntercomDiagramTypes.CUSTOMER_JOURNEY,
  [COMMON_SUBTYPES.SYSTEM_ARCHITECTURE]: IntercomDiagramTypes.SYSTEM_ARCHITECTURE,
  [COMMON_SUBTYPES.DATA_MODEL]: IntercomDiagramTypes.DATA_MODEL,
  [COMMON_SUBTYPES.INTERACTION_FLOW]: IntercomDiagramTypes.INTERACTION_FLOW,
  [COMMON_SUBTYPES.CAPABILITY]: IntercomDiagramTypes.CAPABILITY,
  [AGENT_SUBTYPES.AGENT_INSTRUCTION]: IntercomDiagramTypes.AGENT_INSTRUCTION,
  [AGENT_SUBTYPES.AGENT_INTERACTION]: IntercomDiagramTypes.AGENT_INTERACTION,
  [COMMON_SUBTYPES.WHITEBOARD]: IntercomDiagramTypes.WHITEBOARD
};
